var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useMemo, useState } from "react";
import { FormAppointmentActionDTO } from "../resources/FormAppointmentActionDTO";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogActionType, getCatalogAppointmentStatus } from "../../../store/catalog/actions";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { appointmentActionPatch, appointmentActionPatchClearData, getAppointmentAction } from "../../../store/actions";
import { showErrorToast } from "../../../fnx/showError";
import { useTranslation } from "react-i18next";
import { showToastSuccessMessage } from "../../../fnx/sendSuccessMessage";
export var useAppointmentManager = function (appointmentId, setOpenModalAddAppointmentAction, setTriggerAddAppointmentAction, triggerAddAppointmentAction, showTabAppointmentManager, userId, setSeeToast) {
    var _a = useState([]), appointmentManagerRows = _a[0], setAppointmentManagerRows = _a[1];
    var handleAddAppointmetAction = function () {
        setTriggerAddAppointmentAction(true);
        setOpenModalAddAppointmentAction(true);
    };
    var _b = useState(FormAppointmentActionDTO), formAppointmentActionProps = _b[0], setFormAppointmentActionProps = _b[1];
    var dispatch = useDispatch();
    var responseGetCatalogActionType = useSelector(function (state) {
        var _a;
        return ({
            responseGetCatalogActionType: (_a = state.Catalog.responseGetCatalogActionType) === null || _a === void 0 ? void 0 : _a.data
        });
    }).responseGetCatalogActionType;
    var responseGetCatalogAppointmentStatus = useSelector(function (state) {
        var _a;
        return ({
            responseGetCatalogAppointmentStatus: (_a = state.Catalog.responseGetCatalogAppointmentStatus) === null || _a === void 0 ? void 0 : _a.data
        });
    }).responseGetCatalogAppointmentStatus;
    useEffect(function () {
        if (triggerAddAppointmentAction) {
            dispatch(getCatalogActionType({
                enable: true,
                page: 1,
                limit: 20,
                type: "CATALOG_ACTION_TYPES",
            }));
            dispatch(getCatalogAppointmentStatus({
                enable: true,
                page: 1,
                limit: 20,
                type: "CATALOG_APPOINTMENT_STATUS",
            }));
        }
    }, [triggerAddAppointmentAction]);
    useEffect(function () {
        if (responseGetCatalogActionType) {
            var actionTypeList_1 = responseGetCatalogActionType.map(function (item) { return ({
                id: item.id,
                value: item.code,
                name: item.description
            }); });
            setFormAppointmentActionProps(function (prev) { return (__assign(__assign({}, prev), { actionTypeList: actionTypeList_1 })); });
        }
    }, [responseGetCatalogActionType]);
    useEffect(function () {
        if (responseGetCatalogAppointmentStatus) {
            var AppointmentStatusList = responseGetCatalogAppointmentStatus.map(function (item) { return ({
                id: item.id,
                value: item.code,
                name: item.description
            }); });
            var declineCodeList_1 = ["NI", "OS", "NMG", "DWS"];
            var followUpCodeList_1 = ["A", "PD", "CP", "RW"];
            var statusListDecline_1 = AppointmentStatusList.filter(function (item) {
                return declineCodeList_1.includes(item.value);
            });
            var statusListFollowUp_1 = AppointmentStatusList.filter(function (item) {
                return followUpCodeList_1.includes(item.value);
            });
            setFormAppointmentActionProps(function (prev) { return (__assign(__assign({}, prev), { statusListDecline: statusListDecline_1, statusListFollowUp: statusListFollowUp_1 })); });
        }
    }, [responseGetCatalogAppointmentStatus]);
    var responseGetAppointmentAction = useSelector(function (state) {
        var _a;
        return ({
            responseGetAppointmentAction: (_a = state.Appointment.responseGetAppointmentAction) === null || _a === void 0 ? void 0 : _a.data
        });
    }).responseGetAppointmentAction;
    useEffect(function () {
        if (showTabAppointmentManager && appointmentId) {
            dispatch(getAppointmentAction({
                appointmentId: appointmentId
            }));
        }
    }, [showTabAppointmentManager, appointmentId]);
    useEffect(function () {
        if (responseGetAppointmentAction) {
            var appointmentActions = responseGetAppointmentAction.map(function (item) {
                var formattedDate = new Date(item.date).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                    timeZone: "UTC"
                }).replace(",", "").replace(/\//g, "-");
                return {
                    id: item.id,
                    date: formattedDate,
                    action: item.actionType,
                    status: item.status,
                    comment: item.comment,
                    newAppointmentDate: "",
                    approvedPremium: ""
                };
            });
            setAppointmentManagerRows(appointmentActions);
        }
    }, [responseGetAppointmentAction]);
    var handleSubmitAppointmentAction = function (data) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        // El backend espera el nombre largo (description), no el código.
        // Las listas del catálogo guardan { value: code, name: description },
        // por eso traducimos antes de mandar.
        var actionItem = (_a = formAppointmentActionProps.actionTypeList) === null || _a === void 0 ? void 0 : _a.find(function (i) { return i.value === data.actionType; });
        var statusItem = __spreadArray(__spreadArray([], ((_b = formAppointmentActionProps.statusListFollowUp) !== null && _b !== void 0 ? _b : []), true), ((_c = formAppointmentActionProps.statusListDecline) !== null && _c !== void 0 ? _c : []), true).find(function (i) { return i.value === data.statusType; });
        // El form devuelve approvedPremium como string ("4000"); el backend
        // lo necesita numérico. Si está vacío mandamos null (es como lo
        // representa el response del GET de appointments).
        var rawPremium = data.approvedPremium;
        var premium = null;
        if (rawPremium !== "" && rawPremium != null) {
            var parsed = Number(rawPremium);
            premium = Number.isNaN(parsed) ? null : parsed;
        }
        var payload = {
            userId: userId,
            action: (_d = actionItem === null || actionItem === void 0 ? void 0 : actionItem.name) !== null && _d !== void 0 ? _d : data.actionType,
            status: (_f = (_e = statusItem === null || statusItem === void 0 ? void 0 : statusItem.name) !== null && _e !== void 0 ? _e : data.statusType) !== null && _f !== void 0 ? _f : "",
            comment: (_g = data.comment) !== null && _g !== void 0 ? _g : "",
            premium: premium,
            rescheduleDate: (_h = data.newAppointmentDate) !== null && _h !== void 0 ? _h : ""
        };
        dispatch(appointmentActionPatch({ data: payload }, appointmentId));
    };
    var _c = useSelector(function (state) { return ({
        responseAppointmentActionPatch: state.Appointment.responseAppointmentActionPatch,
        loadingAppointmentActionPatch: state.Appointment.loadingAppointmentActionPatch,
        errorAppointmentActionPatch: state.Appointment.errorAppointmentActionPatch,
    }); }), responseAppointmentActionPatch = _c.responseAppointmentActionPatch, loadingAppointmentActionPatch = _c.loadingAppointmentActionPatch, errorAppointmentActionPatch = _c.errorAppointmentActionPatch;
    useEffect(function () {
        var _a, _b;
        if (responseAppointmentActionPatch) {
            var item = responseAppointmentActionPatch.data;
            var formattedDate = new Date(item.createdAt).toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
                timeZone: "UTC"
            }).replace(",", "").replace(/\//g, "-");
            var newAppointmentAction_1 = {
                id: item.id,
                date: formattedDate,
                action: item.action,
                status: item.status,
                comment: item.comment,
                newAppointmentDate: (_a = item.rescheduleDate) !== null && _a !== void 0 ? _a : "",
                approvedPremium: (_b = item.premium) !== null && _b !== void 0 ? _b : ""
            };
            setAppointmentManagerRows(function (prev) { return __spreadArray(__spreadArray([], prev, true), [newAppointmentAction_1], false); });
            showToastSuccessMessage("Gestión agregada con éxito.", typeAlert.success, setSeeToast);
            dispatch(appointmentActionPatchClearData());
            setOpenModalAddAppointmentAction(false);
        }
    }, [responseAppointmentActionPatch]);
    var t = useTranslation().t;
    useEffect(function () {
        if (errorAppointmentActionPatch) {
            showErrorToast(errorAppointmentActionPatch, setSeeToast, t);
            dispatch(appointmentActionPatchClearData());
            setOpenModalAddAppointmentAction(false);
        }
    }, [errorAppointmentActionPatch]);
    return useMemo(function () { return ({
        appointmentManagerRows: appointmentManagerRows,
        handleAddAppointmetAction: handleAddAppointmetAction,
        handleSubmitAppointmentAction: handleSubmitAppointmentAction,
        formAppointmentActionProps: formAppointmentActionProps,
        loadingAppointmentActionPatch: loadingAppointmentActionPatch
    }); }, [appointmentId, formAppointmentActionProps, appointmentManagerRows, loadingAppointmentActionPatch]);
};
